import type { DeleteOversightAssessmentsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (trpcData: {
  affected_rows: number;
}): DeleteOversightAssessmentsMutation => {
  return {
    delete_oversight_assessment: {
      __typename: 'oversight_assessment_mutation_response',
      affected_rows: trpcData.affected_rows,
    },
  };
};

export const useDeleteOversightAssessmentsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.oversight.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.oversight.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.oversight.oversightAssessmentCount.queryKey(),
        });
      },
    }),
  });

  return {
    deleteOversightAssessments: async (
      ids: string[]
    ): Promise<DeleteOversightAssessmentsMutation> => {
      const result = await mutation.mutateAsync({ Ids: ids });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
